<template>
  <div>
    <modal v-if="!isSend" ref="modal" @close="onClose">
      <template slot="title">ZIPダウンロード</template>
      <template slot="name">出力形式を選択してください（今月残り {{ limitedRemainingCount }}/{{ maxCount }}）<br/></template>
      <template slot="input">
        <div class="common-select">
          <select v-model="localExportOption">
            <option value="relative">相対パス形式</option>
            <option value="absolute">絶対パス形式</option>
          </select>
        </div>
      </template>
      <template class="submit-wrapper" slot="submit">
        <button v-if="limitedRemainingCount > 0 && !isLoading" type="button" @click="onSubmit" class="submit normal-btn">ダウンロード</button>
        <button v-else type="button" disabled class="submit normal-btn">ダウンロード</button>
      </template>
    </modal>
    <modal v-if="isSend" ref="modal" @close="onClose">
      <template slot="title">ダウンロード</template>
      <template slot="name">
        <p>こちらからダウンロードしてください</p>
        <a class="download-link" :href="downloadLink">ダウンロードリンク</a>
      </template>
    </modal>
  </div>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'
import modal from '@/components/Util/Modal'

export default {
  mixins: [ base ],
  props: [
    'extTypeName',
  ],
  data () {
    return {
      isLoading: false,
      isSend: false,
      rawHTML: '',
      mobileCSS: '',
      localExportOption: 'relative',
      downloadLink: '',
      maxCount: 0,
      currentCount: 0,
    }
  },
  components: {
    modal
  },
  created () {
    this.initRateLimit()
  },
  methods: {
    async initRateLimit () {
      await this.$http({
        url: '/plan/rate_limit',
        type: 'GET',
      }).then((json) => {
        const { plan, using } = json.data
        if (this.extTypeName === 'mp') {
          this.maxCount = plan.mp_and_zip_export_max_count
          this.currentCount = using.mp_and_zip_export_max_count
        } else if (this.extTypeName === 'ec_v1') {
          this.maxCount = plan.ec_v1_and_zip_export_max_count
          this.currentCount = using.ec_v1_and_zip_export_max_count
        } else {
          // ec_v2
          this.maxCount = plan.ec_v2_and_zip_export_max_count
          this.currentCount = using.ec_v2_and_zip_export_max_count
        }
      })
    },
    onClose () {
      this.$emit('close')
    },
    async onSubmit () {
      this.isLoading = true
      let sections = null
      const randContentId = this.$utils.string.generateRandContentId()
      // コードパーツ 未使用の画像を削除
      this.$store.commit('deleteCodePartUnUseImage', this.$store.getters.getSectionAll)
      if (this.localExportOption === 'absolute') {
        sections = await this.getReplacedUrlSections(randContentId, 'abs_export')
      } else {
        sections = await this.getReplacedUrlSections(randContentId, 'rel_export')
      }
      this.createRawHTML(sections)
      await this.getContentSize()
      const saveJson = await this.$store.dispatch('savePreviewData')
      if (!saveJson || saveJson.status !== 200) return

      // HTML ファイル(ZIP)を生成するために必要な情報を PHP にわたす。
      const formData = new FormData()
      if (!sections) return
      this.createRawHTML(sections)
      this.mobileCSS = this.createMobileCSS()
      formData.append('randContentId', randContentId)
      formData.append('body', this.rawHTML)
      formData.append('contentId', this.$route.params.id)
      // title
      formData.append('title', this.$store.getters.getContentInfo.name)
      // モバイルスタイルCSS
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      // メール用CSS
      formData.append('headCss', this.createHeadCSS())
      // outlook CSS
      formData.append('outlookCss', this.createOutlookCSS())
      // パス形式 relative or absolute
      formData.append('localExportOption', this.localExportOption)
      await this.$http({
        type: 'POST',
        url: '/zip_content',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          this.isSend = true
          this.downloadLink = json.data.link
        }
      })
    },
  },
  computed: {
    limitedRemainingCount () {
      const remainingCount = this.maxCount - this.currentCount
      return remainingCount <= 0 ? 0 : remainingCount
    }
  },
}
</script>

<style lang="scss" scoped>
.submit {
  font-size: 14px;
  border-radius: 5px;
  color: #fff;
  border: solid 1px #484848;
  background: #484848;
  &:hover {
    background: #484848;
    opacity: 0.8;
  }
  &:disabled {
    border: solid 1px #6c757d;
    background: #6c757d;
    opacity: 0.8;
    cursor: default;
  }
}

.download-link {
  color: blue;
}

.normal-btn {
  width: 150px;
}
</style>
